import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { trySayingSuffix, voiceCommandParamExample, voiceCommandParamLabel, type VoiceCommandDoc } from '../../../data/voiceCommandsDocs';
import { CommonIcon } from '../../common/CommonIcon';
import { LiquidGlassRowCard } from '../../common/LiquidGlassRowCard';
import { voiceCommandLabel, voiceCommandsSectionLabelSx } from './voiceCommandsDocsShared';

interface VoiceCommandsDocsDetailPanelProps {
  cmd: VoiceCommandDoc;
  sortedParams: VoiceCommandDoc['params'];
}

export const VoiceCommandsDocsDetailPanel: FC<VoiceCommandsDocsDetailPanelProps> = ({
  cmd,
  sortedParams,
}) => {
  const { t } = useTranslation();
  const trySuffix = trySayingSuffix(cmd);
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <LiquidGlassRowCard>
          <Box sx={{ p: 1.5 }}>
            <Text
              style={{
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                color: 'var(--tg-theme-hint-color)',
                opacity: 0.8,
                marginBottom: 8,
                display: 'block',
              }}
            >
              {t('voice.trySaying')}
            </Text>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
              <Box sx={{ flexShrink: 0, lineHeight: 0, pt: '2px' }}>
                <CommonIcon icon={cmd.icon} type="filled" size={14} color="var(--tg-theme-button-color)" />
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Text
                  style={{
                    fontSize: 14,
                    fontStyle: 'italic',
                    lineHeight: 1.6,
                    color: 'var(--tg-theme-text-color)',
                    display: 'block',
                  }}
                >
                  <span
                    style={{ color: 'var(--tg-theme-button-color)', fontStyle: 'normal', fontWeight: 600 }}
                  >
                    {voiceCommandLabel(cmd)}
                  </span>
                  {trySuffix ? <span style={{ opacity: 0.7 }}> {trySuffix}</span> : null}
                </Text>
              </Box>
            </Box>
          </Box>
        </LiquidGlassRowCard>
      </Box>

      <Text style={{ ...voiceCommandsSectionLabelSx, marginBottom: 8 }}>
        {t('voice.parameters', { count: sortedParams.length })}
      </Text>
      <Stack gap={1} sx={{ mb: 0 }}>
        {sortedParams.map((p) => (
          <LiquidGlassRowCard key={p.id}>
            <Box sx={{ p: 1.25 }}>
              <Text
                style={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: 'var(--tg-theme-button-color)',
                  marginBottom: 6,
                  display: 'block',
                }}
              >
                {voiceCommandParamLabel(cmd, p)}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  color: 'var(--tg-theme-hint-color)',
                  lineHeight: 1.45,
                  fontStyle: 'italic',
                }}
              >
                “{voiceCommandParamExample(cmd, p)}”
              </Text>
            </Box>
          </LiquidGlassRowCard>
        ))}
      </Stack>
    </>
  );
};
